import { washLanguageData } from '@/utils/wash.js'
import { getNodeByFlag } from '../../common/controlBar/controlBarDialog/metaComponent/utils'
import { createMuiltLanguagesJson } from "@/components/widgets/nav/repeatNumber.js";
import { deepCopy } from '@/mm/utils.js'

const washData = (walkedNode) => {
  const design = walkedNode.data.design
  const list = ['diannao', 'pingban', 'shouji']

  if (design && typeof design['topStyle_textAlign'].diannao !== 'object') {
    list.forEach((item) => {
      design['topStyle_textAlign'][item] = createMuiltLanguagesJson(
        design['topStyle_textAlign'][item],
        {
          rtl: design['topStyle_textAlign'][item] === 'right' ? 'left' : 'right'
        }
      )
    })
  }

  if (design && typeof design['secondItem_paddingLeft'].diannao !== 'object') {
    list.forEach((item) => {
      design['secondItem_paddingLeft'][item] = createMuiltLanguagesJson(
        design['secondItem_paddingLeft'][item],
        {
          rtl: design['secondItem_paddingRight'][item]
        }
      )
    })
  }
  if (design && typeof design['secondItem_paddingRight'].diannao !== 'object') {
    list.forEach((item) => {
      design['secondItem_paddingRight'][item] = createMuiltLanguagesJson(
        design['secondItem_paddingRight'][item],
        {
          rtl: design['secondItem_paddingLeft'][item]
        }
      )
    })
  }

  if (design && typeof design['thirdItem_paddingLeft'].diannao !== 'object') {
    list.forEach((item) => {
      design['thirdItem_paddingLeft'][item] = createMuiltLanguagesJson(
        design['thirdItem_paddingLeft'][item],
        {
          rtl: design['thirdItem_paddingRight'][item]
        }
      )
    })
  }
  if (design && typeof design['thirdItem_paddingRight'].diannao !== 'object') {
    list.forEach((item) => {
      design['thirdItem_paddingRight'][item] = createMuiltLanguagesJson(
        design['thirdItem_paddingRight'][item],
        {
          rtl: design['thirdItem_paddingLeft'][item]
        }
      )
    })
  }
}
export { washData }
